import { render, staticRenderFns } from "./validateBlock.vue?vue&type=template&id=a2e6ba5c&scoped=true"
import script from "./validateBlock.vue?vue&type=script&lang=js"
export * from "./validateBlock.vue?vue&type=script&lang=js"
import style0 from "./validateBlock.vue?vue&type=style&index=0&id=a2e6ba5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e6ba5c",
  null
  
)

export default component.exports